import { Route, Routes } from "react-router-dom";
import { NotAuthorizedPage } from "../pages/ErrorPages/NotAuthorizedPage";
import { Initializer } from "../layouts/Initializer";
import { SignInPage } from "../pages/Authentication/SignInPage";
import { NotFoundPage } from "../pages/ErrorPages/NotFoundPage";
import { ForbiddenPage } from "../pages/ErrorPages/ForbiddenPage";
import { MaintenancePage } from "../pages/MaintenancePage/MaintenancePage";
import { SecondAuthFactor } from "../pages/Authentication/SecondAuthFactor";
import { OverviewPage } from "../pages/OverviewPage";
import { PaymentPage } from "../pages/PaymentPage";
import { SuccessPage } from "../pages/ConfirmationPages/SuccessPage";
import { ErrorPage } from "../pages/ConfirmationPages/ErrorPage";

export const GeneralRoutes = () => {
    return (
        <Routes>
            <Route path="/*" element={<Initializer />}>
                <Route index element={<SignInPage />} />
                <Route path="second-auth-factor" element={<SecondAuthFactor />} />
                <Route path="overview" element={<OverviewPage />} />
                <Route path="payment" element={<PaymentPage />} />
                <Route path="confirmation/*">
                    <Route path="success" element={<SuccessPage />} />
                    <Route path="error" element={<ErrorPage />} />
                </Route>
                <Route path="errors/*">
                    <Route path="not-found" element={<NotFoundPage />} />
                    <Route path="not-authorized" element={<NotAuthorizedPage />} />
                    <Route path="forbidden" element={<ForbiddenPage />} />
                </Route>
            </Route>
            <Route path="/maintenance" element={<MaintenancePage />} />
        </Routes>
    );
};
